import React from "react";
import { Link } from "gatsby";
import szfy from "../assets/images/medical_article/szfy.jpg";
import shptyy from "../assets/images/medical_article/shptyy.jpg";
import njsetyy from "../assets/images/medical_article/njsetyy.jpg";
import medical from "../assets/images/medical_article/medical.jpg";
import tjykdxzyy from "../assets/images/medical_article/tjykdxzyy.jpg";
import szkjcyy from "../assets/images/medical_article/szkjcyy.jpg";
import n2025 from "../assets/images/notice/2025.png";

const Article = () => {
  return (
    <section className="blog-one blog-page">
      <div className="container">
        <div className="row">
          {/* <div className="col-lg-4">
            <div className="blog-one__single">
              <div className="blog-one__image1">
                <img src={n2025} alt="" />
                <Link to="/article-notice01" className="blog-one__plus">
                  <i className="kipso-icon-plus-symbol"></i>
                </Link>
              </div>
              <div className="blog-one__content text-center">
                <div className="blog-one__meta">
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted On Jan 19"
                  >
                    <i className="fa fa-calendar-alt"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="No Comments"
                  >
                    <i className="fa fa-comments"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted By Admin"
                  >
                    <i className="fa fa-user"></i>
                  </a>
                </div>
                <h2 className="blog-one__title">
                  <Link to="/article-notice01">
                 新发布! 关于 2025 年代理商医疗设备产品升级的通知!
                  </Link>
                </h2>
                <p className="blog-one__text">
                苏州卫捷医药科技有限公司
                </p>
                <Link to="/article-notice01" className="blog-one__link">
                  阅  读  详  情
                </Link>
              </div>
            </div>
          </div> */}
          <div className="col-lg-4">
            <div className="blog-one__single">
              <div className="blog-one__image1">
                <img src={szfy} alt="" />
                <Link to="/article-detail01" className="blog-one__plus">
                  <i className="kipso-icon-plus-symbol"></i>
                </Link>
              </div>
              <div className="blog-one__content text-center">
                <div className="blog-one__meta">
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted On Jan 19"
                  >
                    <i className="fa fa-calendar-alt"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="No Comments"
                  >
                    <i className="fa fa-comments"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted By Admin"
                  >
                    <i className="fa fa-user"></i>
                  </a>
                </div>
                <h2 className="blog-one__title">
                  <Link to="/article-details01">
                  多环节质量控制在降低静配中心退药率的应用实践
                  </Link>
                </h2>
                <p className="blog-one__text">
                华中科技大学同济医学院附属武汉中心医院药学部
                </p>
                <Link to="/article-detail01" className="blog-one__link">
                  阅  读  详  情
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="blog-one__single">
              <div className="blog-one__image1">
                <img src={shptyy} alt="" />
                <Link to="/article-details02" className="blog-one__plus">
                  <i className="kipso-icon-plus-symbol"></i>
                </Link>
              </div>
              <div className="blog-one__content text-center">
                <div className="blog-one__meta">
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted On Jan 19"
                  >
                    <i className="fa fa-calendar-alt"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="No Comments"
                  >
                    <i className="fa fa-comments"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted By Admin"
                  >
                    <i className="fa fa-user"></i>
                  </a>
                </div>
                <h2 className="blog-one__title">
                  <Link to="/article-details02">
                  医院静脉用药调配中心的自动化系统建设与实践
                  </Link>
                </h2>
                <p className="blog-one__text">
                上海普陀中心医院药学部
                </p>
                <Link to="/article-details02" className="blog-one__link">
                  阅  读  详  情
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="blog-one__single">
              <div className="blog-one__image1">
                <img src={njsetyy} alt="" />
                <Link to="/article-details3" className="blog-one__plus">
                  <i className="kipso-icon-plus-symbol"></i>
                </Link>
              </div>
              <div className="blog-one__content text-center">
                <div className="blog-one__meta">
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted On Jan 19"
                  >
                    <i className="fa fa-calendar-alt"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="No Comments"
                  >
                    <i className="fa fa-comments"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted By Admin"
                  >
                    <i className="fa fa-user"></i>
                  </a>
                </div>
                <h2 className="blog-one__title">
                  <Link to="/article-details3">
                  智能标签打印系统在医院静脉用药集中调配中心的应用
                  </Link>
                </h2>
                <p className="blog-one__text">
                南京医科大学附属儿童医院药学部
                </p>
                <Link to="/article-details3" className="blog-one__link">
                  阅  读  详  情
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="blog-one__single">
              <div className="blog-one__image1">
                <img src={medical} alt="" />
                <Link to="/article-details04" className="blog-one__plus">
                  <i className="kipso-icon-plus-symbol"></i>
                </Link>
              </div>
              <div className="blog-one__content text-center">
                <div className="blog-one__meta">
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted On Jan 19"
                  >
                    <i className="fa fa-calendar-alt"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="No Comments"
                  >
                    <i className="fa fa-comments"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted By Admin"
                  >
                    <i className="fa fa-user"></i>
                  </a>
                </div>
                <h2 className="blog-one__title">
                  <Link to="/article-details04">
                  静脉用药集中调配中心智能化、信息化、均质化建设的实践
                  </Link>
                </h2>
                <p className="blog-one__text">
                匿名
                </p>
                <Link to="/article-details04" className="blog-one__link">
                  阅  读  详  情
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="blog-one__single">
              <div className="blog-one__image1">
                <img src={tjykdxzyy} alt="" />
                <Link to="/article-details05" className="blog-one__plus">
                  <i className="kipso-icon-plus-symbol"></i>
                </Link>
              </div>
              <div className="blog-one__content text-center">
                <div className="blog-one__meta">
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted On Jan 19"
                  >
                    <i className="fa fa-calendar-alt"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="No Comments"
                  >
                    <i className="fa fa-comments"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted By Admin"
                  >
                    <i className="fa fa-user"></i>
                  </a>
                </div>
                <h2 className="blog-one__title">
                  <Link to="/article-details05">
                  自动化建设提升我院 PIVAS 药学服务质量            &nbsp;
                  </Link>
                </h2>
                <p className="blog-one__text">
                天津医科大学总医院
                </p>
                <Link to="/article-details05" className="blog-one__link">
                  阅  读  详  情
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="blog-one__single">
              <div className="blog-one__image1">
                <img src={szkjcyy} alt="" />
                <Link to="/article-details06" className="blog-one__plus">
                  <i className="kipso-icon-plus-symbol"></i>
                </Link>
              </div>
              <div className="blog-one__content text-center">
                <div className="blog-one__meta">
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted On Jan 19"
                  >
                    <i className="fa fa-calendar-alt"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="No Comments"
                  >
                    <i className="fa fa-comments"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted By Admin"
                  >
                    <i className="fa fa-user"></i>
                  </a>
                </div>
                <h2 className="blog-one__title">
                  <Link to="/article-details06">
                  一体化智能 PIVAS/住院药房的构建和应用
                  </Link>
                </h2>
                <p className="blog-one__text">
                苏州科技城医院
                </p>
                <Link to="/article-details06" className="blog-one__link">
                  阅  读  详  情
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="post-pagination">
          <a href="#none">
            <i className="fa fa-angle-double-left"></i>
          </a>
          <a className="active" href="#none">
            1
          </a>
          <a href="#none">2</a>
          <a href="#none">3</a>
          <a href="#none">4</a>
          <a href="#none">
            <i className="fa fa-angle-double-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Article;
